import { useState } from "react";

const useUserContextManager = () => {
  //a temp default league
  const [user, setUser] = useState({ id: 0 });
  return [user, setUser];
};

export default useUserContextManager;
